const labelConfig = {
  fontColor: () => "#000",
  fontFamily: () => "'FOW Theinhardt', sans-serif",
  fontSize: () => 10,
  fontWeight: () => 400
};

const axisConfig = {
  duration: 0,
  barConfig: {
    stroke: "transparent",
    strokeWidth: 1
  },
  gridConfig: {
    stroke: d => Math.abs(d.id) === 0 ? "#666" : "#fff",
    strokeWidth: 1
  },
  labelConfig: labelConfig,
  shapeConfig: {
    labelConfig: labelConfig,
    stroke: "#efefef",
    strokeWidth: 1
  },
  tickSize: 5,
  titleConfig: {
    fontColor: () => "#666",
    fontFamily: () => "'FOW Theinhardt', sans-serif",
    fontSize: () => 14,
    fontWeight: () => 400
  }
};

export default {
  xConfig: {
    ...axisConfig,
    barConfig: {
      stroke: "#666",
      strokeWidth: 1
    }
  },
  duration: 0,
  yConfig: {
    ...axisConfig,
    scale: "auto"
  },
  y2Config: {
    ...axisConfig,
    scale: "auto"
  },
  labelConfig: {
    fontFamily: () => "'FOW Theinhardt', sans-serif"
  },
  shapeConfig: {
    duration: 0,
    Bar: {
      height: 20,
      width: 20,
      duration: 0,
      labelBounds: (d, ix, s) => { // It works great with horizontal barCharts
        const width = s.width < 100 ? 100 : s.width;
        let x = d.value < 0 ? -width * 2 : width;
        const diff = s.width < 100? 100 - s.width:0;
        x = d.value < 0?x+diff:x-diff;
        const resp = {
          width: width,
          height: 40,
          x: x,
          y: -38 / 2
        };
        return resp;
      },
      labelConfig: {
        textAnchor: (d) => { return d.value < 0 ? "end" : "start"},
        fontColor: () => "#000",
        fontFamily: () => "'FOW Theinhardt', sans-serif",
        fontSize: () => 12,
        fontWeight: () => 400
      },
    }
  },
  legendTooltip: {
    body: "",
    footer: "",
  },
  on: {"click.legend": () => {}}
};
